import { commonComponents as cc } from "@/components/common";
import { selectFormByIdQueryOptions } from "@/features/forms/api/selectFormById";
import type { FormViewT } from "@patient-watch/types";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => {
    const { form } = Route.useLoaderData();

    return (
        <section className="max-w-lg">
            <cc.Title words={form.form_name} description={form.form_description ?? undefined} />
        </section>
    );
};

export const Route = createFileRoute("/tracker/$trackerId/form/$formId/entry/$entryId/page/")({
    component: Page,
    loader: async ({ context, params }) => {
        const form = (await context?.queryClient.ensureQueryData(
            selectFormByIdQueryOptions(params.formId)
        )) as FormViewT;
        return { form };
    },
});
